import { render } from "./DeLoading.vue?vue&type=template&id=13b36e7c"
import script from "./DeLoading.vue?vue&type=script&lang=js"
export * from "./DeLoading.vue?vue&type=script&lang=js"

import "./DeLoading.vue?vue&type=style&index=0&id=13b36e7c&lang=css"

import exportComponent from "/media/doevent/Data/doevent/project/pmb/db/de-db-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__